<template>
    <input :type="type" :value="value" :placeholder="placeholder" :disabled="disabled" :required="required"
        @input="$emit('input', $event.target.value)"
        class="tw:w-full tw:px-4 tw:py-2 tw:bg-gray-50 focus:tw:bg-white tw:border tw:border-gray-300 tw:rounded-lg focus:tw:ring-2 focus:tw:ring-blue-500 focus:tw:border-blue-500 tw:transition-colors tw:outline-none tw:text-xs tw:text-gray-900 disabled:tw:bg-gray-100 disabled:tw:text-gray-500 disabled:tw:cursor-not-allowed">
</template>

<script>
export default {
    name: 'BaseInput',
    props: {
        // En Vue 2, v-model pasa automáticamente una prop llamada "value"
        value: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: 'text' // Puede ser 'email', 'password', 'date', etc.
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>